import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { createBlobDirectory } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function createDirectory({
  params,
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(createBlobDirectory(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: {
    Title: string;
    Content: string;
    Container: string;
    streamContent: string;
  };
  accountId: number;
};

type TSnapshot = unknown;

function useCreateBlobDirectory(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId }: TVariables) => {
    const renamedResult = await createDirectory({
      params,
      accountId,
    });
    if (renamedResult.Data) {
      queryClient.invalidateQueries(['get_file_tree'], {
        refetchInactive: true,
      });
    } else if (renamedResult.Errors) throw renamedResult;
    return renamedResult;
  });
}

export { useCreateBlobDirectory };
